export default "__VITE_ASSET__ccykVrfl__"